$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');
  const locationId = $('body').attr('event_id');
  if (p === 'product_management' && a === 'list') {
    $(document).on('submit', '#inventory-filtered-form', function (e) {
      e.preventDefault();
      let searchString = $('#search_string').val();
      let supplierId = $(this).val();
      const formData = new FormData(e.target);
      formData.append('search_string', searchString);
      formData.append('page', 1);
      formData.append('product_type', 0);

      $.ajax({
        type: 'POST',
        url: '/ajax/product_management/search',
        data: formData,
        enctype: 'multipart/form-data',
        async: true,
        cache: false,
        processData: false,
        contentType: false,
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $('#product-list').empty();
            $('#product-list').append(data.html);
          }
          $('#product-filter-list').hide();
          setTimeout(() => {
            $('select').select2({
              theme: 'bootstrap4',
            });
          }, 200);
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });
  }
});
